
import React, { useState, useEffect } from 'react';

import Grid from "@mui/material/Grid2";
import DandDAPI from '@dndUtilities/system_api';
import StringBox from './strings/StringBox';
import { Button } from '@mui/material';

interface Props { 
  userStatus: "" | "New User" | "Updating User" | "Error";
  onComplete: () => void;
}

const api = DandDAPI.getInstance();

export default function NewUserInput({ 
  userStatus,
  onComplete
}: Props) {
  const [username, setUsername] = React.useState("");
  
  useEffect(() => {
    if (api.user && userStatus !== "Error") {
      setUsername(api.user.profile_name);
    }
  }, [api.user, userStatus]);

  const submit = async () => {
    const user = api.user;
    // debugger;
    if (user) {
      user.name = username;
      const new_obj = user.clone();
      await api.upsertObject("user", new_obj);
      onComplete();
    }
  }

  if (userStatus === "Error") {
    return (
      <div>
          We ran into an error with setting up your account. 
          Please check your internet connection, refresh your, browser and try again. 
          If the problem persists please contact us so we can solve the problem.
      </div>
    );
  } else {
    const user = api.user;
    if (user) {
      if (userStatus === "New User") {
        return (
          <Grid container spacing={0} direction="row">
            <Grid size={12} className="header centered padded">Welcome to Homebrew Labs!</Grid>
            <Grid size={12} className="padded">
              You can choose to set a Username specific to your Homebrew Labs account. 
              We default to the one that came with your profile.
              You won't be able to easily change your username later.
            </Grid>
            <Grid size={12} className="padded">
              <StringBox 
                name="Username"
                value={username}
                onBlur={setUsername}
              />
            </Grid>
            <Grid size={12} className="padded" style={{ float: "right"}}>
              <Button
                variant="contained"
                color="primary"
                size="large" 
                onClick={submit}>
                Save
              </Button>
            </Grid>
          </Grid>
        );
      } else if (userStatus === "Updating User") {
        return (
          <Grid container spacing={0} direction="row">
            <Grid size={12} className="padded">
              Choose a Username specific to your Homebrew Labs account. 
              We default to the one that came with your profile.
              You won't be able to easily change your username later.
            </Grid>
            <Grid size={12} className="padded">
              <StringBox 
                name="Username"
                value={username}
                onBlur={setUsername}
              />
            </Grid>
            <Grid size={12} className="padded" style={{ float: "right"}}>
              <Button
                variant="contained"
                color="primary"
                size="large" 
                onClick={submit}>
                Save
              </Button>
            </Grid>
          </Grid>
        );
      }
    }
  }

  return <></>;
}

